export default {
	INFO: "Info",
	ERROR: "Error",
	WARNING: "Warning",
	ALL: "All",
	FATAL: "Fatal",
	OFF: "Off",
	TRACE: "Trace",
	TRACE_INT: "Trace int",
	WARN: "Warn",
	X_TRACE_INT: "X trace int"
};
